var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.757,
    height: 15.757,
    viewBox: "0 0 15.757 15.757",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "world") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#758091;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.871,3a7.879,7.879,0,1,0,7.886,7.879A7.875,7.875,0,0,0,10.871,3Zm5.46,4.727H14.006a12.329,12.329,0,0,0-1.087-2.8A6.326,6.326,0,0,1,16.331,7.727Zm-5.452-3.12a11.1,11.1,0,0,1,1.5,3.12H9.374A11.1,11.1,0,0,1,10.879,4.607Zm-6.1,7.847a6.163,6.163,0,0,1,0-3.151H7.444a13.012,13.012,0,0,0-.11,1.576,13.012,13.012,0,0,0,.11,1.576Zm.646,1.576H7.751a12.329,12.329,0,0,0,1.087,2.8A6.292,6.292,0,0,1,5.427,14.03Zm2.324-6.3H5.427a6.292,6.292,0,0,1,3.411-2.8A12.329,12.329,0,0,0,7.751,7.727Zm3.128,9.423a11.1,11.1,0,0,1-1.5-3.12h3.01A11.1,11.1,0,0,1,10.879,17.15Zm1.844-4.7H9.035a11.591,11.591,0,0,1-.126-1.576A11.491,11.491,0,0,1,9.035,9.3h3.687a11.491,11.491,0,0,1,.126,1.576A11.592,11.592,0,0,1,12.722,12.454Zm.2,4.38a12.329,12.329,0,0,0,1.087-2.8h2.324a6.326,6.326,0,0,1-3.411,2.8Zm1.395-4.38a13.012,13.012,0,0,0,.11-1.576,13.012,13.012,0,0,0-.11-1.576h2.663a6.163,6.163,0,0,1,0,3.151Z",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.2a7360dd302e9ece011c554b3de04f8c.svg";
export { ForwardRef as ReactComponent };